import { AssetManagerModel } from "./asset-manager.model";
import { PropertyModel } from "./property.model";

export class QuestionnaireModel
{
    public id: string;
    public name: string;
    public questionnaire_template_id: string;
    public questionnaire_template_name: string;
    public date_created: Date;
    public created_by: string;
    public date_updated?: Date;
    public updated_by: string;
    public property_id?: string;
    public asset_manager_id: string;
    public asset_manager?: AssetManagerModel;
    public internal_property?: string;
    public status: string;
    public questionnaire_response : string;
    public property: PropertyModel;
    public additional_note: string;
}
export class QuestionnaireValidationResult{
  public section_name: string;
  public label: string;

}
export class  QuestionnaireStatus{
  static readonly INCOMPLETE: string = '1';
  static readonly COMPLETED: string = '2';
  static readonly APPROVED: string = '3';
}

export class QuestionnaireTemplateModel
{
    public id: string;
    public name: string;
    public notes: string;
    public template : string;

}
